module.exports = __webpack_public_path__ + "static/img/taide-art-navbar-white.09bdc77.png";